import React from "react";
import { colors } from "../../../styles/common";
export const ArrowDownIcon = (props) => {
    const { fillColor = colors.lightGray, overideStyle = {} } = props;
    return (<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={overideStyle}>
			<path d="M6.27441 6.04628L10.8869 1.42098C11.038 1.26944 11.0377 1.02409 10.8861 0.872798C10.7346 0.721627 10.4891 0.722017 10.338 0.873579L5.99998 5.22357L1.66203 0.873421C1.51086 0.721879 1.26553 0.721488 1.11397 0.87264C1.03799 0.94848 1 1.04784 1 1.14719C1 1.24629 1.03773 1.34526 1.11318 1.42096L5.72557 6.04628C5.79819 6.11927 5.89701 6.16023 5.99998 6.16023C6.10295 6.16023 6.20166 6.11915 6.27441 6.04628Z" fill="white" stroke={fillColor}/>
		</svg>);
};
